import { patientNamespace } from "@/store/modules/patient";
import { GraphRange, PopupDescription } from "@/store/types";
import Vue from "vue";
import Component from "vue-class-component";
import { Getter } from "vuex-class";

@Component
export default class GraphRanges extends Vue {
  @Getter("popupDescription", patientNamespace)
  popupDescription!: PopupDescription;

  times: GraphRange[] = [];
  selectedTime: number = 0;

  created() {
    if (
      this.popupDescription.popupConfig &&
      this.popupDescription.popupConfig.graphRanges &&
      this.popupDescription.popupConfig.graphStartingIndex !== undefined
    ) {
      this.times = this.popupDescription.popupConfig.graphRanges;
      const time = this.times[
        this.popupDescription.popupConfig.graphStartingIndex
      ];
      if (time) {
        this.selectedTime = time.hours;
      }
    }
  }
}
